/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Supervizor APIs
 * Here is the list of the API endpoints of Supervizor. Click on one to display its implementation. 

Some APIs are protected and require a Bearer token in the Authorization header
 * OpenAPI spec version: 1.0
 */

/**
 * Must be either "USER" or "USER_GROUP"
 */
export type SubjectDtoType = typeof SubjectDtoType[keyof typeof SubjectDtoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubjectDtoType = {
  USER: 'USER',
  USER_GROUP: 'USER_GROUP',
} as const;
